import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit-logs", { params: { limit: 500 } }).then((r) => setItems(r.data)); }, []);
  const filtered = items.filter((l) => !q ||
    l.action?.includes(q) || l.entity?.includes(q) || l.actor_email?.includes(q));

  return (
    <Layout>
      <div className="fade-in space-y-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <h1 className="text-2xl font-semibold tracking-tight" style={{fontFamily:'Outfit'}}>Audit logs</h1>
          <Input placeholder="Filter…" value={q} onChange={(e)=>setQ(e.target.value)} className="w-full md:w-64" data-testid="audit-search"/>
        </div>
        <Card className="rounded-xl border-slate-200"><CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
                <tr>
                  <th className="text-left px-4 py-2">Time</th>
                  <th className="text-left px-4 py-2">Actor</th>
                  <th className="text-left px-4 py-2">Role</th>
                  <th className="text-left px-4 py-2">Action</th>
                  <th className="text-left px-4 py-2">Entity</th>
                  <th className="text-left px-4 py-2">Entity ID</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((l) => (
                  <tr key={l.id} className="border-t border-slate-100" data-testid={`audit-${l.id}`}>
                    <td className="px-4 py-2 whitespace-nowrap">{new Date(l.timestamp).toLocaleString()}</td>
                    <td className="px-4 py-2">{l.actor_email}</td>
                    <td className="px-4 py-2 capitalize">{l.role}</td>
                    <td className="px-4 py-2 font-mono text-xs">{l.action}</td>
                    <td className="px-4 py-2">{l.entity}</td>
                    <td className="px-4 py-2 font-mono text-xs text-slate-500">{l.entity_id?.slice(0,8)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent></Card>
      </div>
    </Layout>
  );
}
